/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../../../projects/icemedx-lib/src/services/baseapp.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { IcecontrolPermission } from '../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../icemedx-lib/src/login/login.config';

@Injectable()
export class AppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);
  }

  public defaultMenus() {
    super.defaultMenus();
    this.payerdomainMenus();

  }
}
